import {useEffect, useState} from "react";
import {getLogo} from "../../services/httpServices";
import blobToDataURL from "../../utils/blobToDataURL";

export default function LogoMarque({id, alt}) {
    const [logo, setLogo] = useState(null)

    useEffect(() => {
        getLogo(id)
            .then(res => blobToDataURL(res.data))
            .then(setLogo)
            .catch(() => setLogo(null))
    }, [id])

    return <img src={logo} alt={alt} style={{maxWidth: "100%", maxHeight: "100%"}}/>
}
